import { useContext, useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router";
import "./App.css";
import { FirebaseContext } from "./context/FirebaseContext";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import {
  Spin,
  Button,
  Layout,
  Avatar,
  Space,
  Typography,
  Row,
  Col,
} from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import Sidebar from "./components/Sidebar";
import SectionContent from "./components/SectionContent";
import ProjectWorkspace from "./components/ProjectWorkspace";

const { Header, Content, Footer } = Layout;

// Componente principal del layout
function MainLayout() {
  const [isAuth, setIsAuth] = useState(false);
  const [loading, setLoading] = useState(true);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const firebase = useContext(FirebaseContext);
  const auth = firebase.auth;
  const user = auth.currentUser;

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsAuth(!!user);
      setLoading(false);
    });
    return () => unsubscribe();
  }, [auth]);

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    provider.addScope("https://www.googleapis.com/auth/spreadsheets");
    provider.addScope("https://www.googleapis.com/auth/drive.file");
    try {
      setLoading(true);
      const result = await signInWithPopup(auth, provider);
      const credential = GoogleAuthProvider.credentialFromResult(result);
      if (credential) {
        const token = credential.accessToken || "";
        localStorage.setItem("token", token);
      }
      setIsAuth(true);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  if (loading) {
    return (
      <Spin
        spinning={true}
        tip="Cargando..."
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      />
    );
  }

  if (!isAuth) {
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <Content
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <h2>Bienvenido</h2>
            <Button type="primary" onClick={handleGoogleLogin} size="large">
              Iniciar sesión con Google
            </Button>
          </div>
        </Content>
      </Layout>
    );
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header
        style={{
          position: "fixed",
          top: 0,
          zIndex: 1000,
          width: "100%",
          padding: "0 48px",
          background: "#001529",
        }}
      >
        <Row align="middle" justify="space-between" style={{ width: "100%" }}>
          <Col>
            <Typography.Title level={4} style={{ color: "white", margin: 0 }}>
              Gemini RQ Bot
            </Typography.Title>
          </Col>
          <Col>
            <Space size="middle">
              <Avatar
                src={user?.photoURL || undefined}
                icon={!user?.photoURL ? <UserOutlined /> : undefined}
                alt={user?.displayName || "Usuario"}
              />
              <Typography.Text style={{ color: "white" }}>
                {user?.displayName || user?.email || "Usuario"}
              </Typography.Text>
              <Button
                icon={<LogoutOutlined />}
                onClick={() => auth.signOut()}
                type="primary"
                danger
              >
                Cerrar sesión
              </Button>
            </Space>
          </Col>
        </Row>
      </Header>

      <Layout style={{ marginTop: 64 }}>
        <Sidebar
          collapsed={sidebarCollapsed}
          onCollapse={setSidebarCollapsed}
        />

        <Layout
          style={{
            marginLeft: sidebarCollapsed ? 60 : 240,
            transition: "margin-left 0.2s",
          }}
        >
          <Content
            style={{
              minHeight: "calc(100vh - 64px)",
              background: "#f7f7f7",
            }}
          >
            <Outlet />
          </Content>

          <Footer style={{ textAlign: "center", background: "#f7f7f7" }}>
            Gemini RQ Bot ©2025 - Análisis de imágenes con IA
          </Footer>
        </Layout>
      </Layout>
    </Layout>
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <SectionContent activeSection="workspace" />,
      },
      {
        path: "settings",
        element: <SectionContent activeSection="settings" />,
      },
      {
        path: "project/:projectId",
        element: <ProjectWorkspace />,
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
